import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';

const FeatureItem = ({ image, title, description, buttonText, buttonLink, reverse = false }) => (
  <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} md:items-center`}>
    <div className="md:w-1/3">
      <div className="aspect-w-4 aspect-h-3 rounded-lg overflow-hidden shadow-lg">
        <img className="object-cover" src={image} alt={title} />
      </div>
    </div>
    <div className={`md:w-2/3 ${reverse ? 'md:pr-10' : 'md:pl-10'} mt-6 md:mt-0`}>
      <h3 className="text-2xl font-bold text-gray-900 mb-3">{title}</h3>
      <div className="prose prose-indigo max-w-none">
        {description}
      </div>
      <div className="mt-4">
        <Link to={buttonLink}>
          <Button>{buttonText}</Button>
        </Link>
      </div>
    </div>
  </div>
);

const AboutFeatures = () => {
  return (
    <div className="p-6 sm:p-10">
      <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">
        Neler Sunuyoruz?
      </h2>
      <div className="space-y-8">
        <FeatureItem
          image="/api/placeholder/600/450"
          title="Harmony Lab Studio"
          description={
            <>
              <p>İçerisinde çeşitli enstrümanlar ve kayıt ekipmanları bulunan profesyonel müzik odamızda pratik yapabilirsiniz:</p>
              <ul>
                <li>Akustik ve elektro gitarlar</li>
                <li>Bas gitar</li>
                <li>Keyboard/Synthesizer</li>
                <li>Bateri seti</li>
                <li>Mikrofonlar ve amfiler</li>
                <li>Mixer ve kayıt ekipmanları</li>
              </ul>
            </>
          }
          buttonText="Rezervasyon Yap"
          buttonLink="/reserve"
        />
        
        <FeatureItem
          image="/api/placeholder/600/450"
          title="Müzik Atölyeleri"
          description={
            <>
              <p>Düzenli olarak gerçekleştirilen atölyelerle enstrüman çalma ve müzik teorisi konularında kendinizi geliştirebilirsiniz:</p>
              <ul>
                <li>Temel gitar, piyano, bateri dersleri</li>
                <li>Müzik teorisi atölyeleri</li>
                <li>Ses kayıt teknikleri eğitimleri</li>
                <li>Müzik prodüksiyon çalıştayları</li>
                <li>Deneyimli müzisyenlerden özel dersler</li>
              </ul>
            </>
          }
          buttonText="Etkinliklere Göz At"
          buttonLink="/events"
          reverse={true}
        />
        
        <FeatureItem
          image="/api/placeholder/600/450"
          title="Kampüs Konserleri"
          description={
            <>
              <p>Her dönem düzenlediğimiz konserlerle müziğinizi kampüs topluluğuyla paylaşma fırsatı bulabilirsiniz:</p>
              <ul>
                <li>Düzenli akustik geceler</li>
                <li>Kampüs şenlikleri performansları</li>
                <li>Open mic etkinlikleri</li>
                <li>Tematik konserler (rock gecesi, caz performansları vb.)</li>
                <li>Jam session'lar</li>
              </ul>
            </>
          }
          buttonText="Etkinliklere Göz At"
          buttonLink="/events"
        />
      </div>
    </div>
  );
};

export default AboutFeatures;